import './NuiAccordion.less';
import React, { ReactNode, useState } from 'react';
import NuiAccordionHeader from './NuiAccordionHeader';

export interface NuiAccordionTitleProps {
    header: string;
    isOpen?: boolean;
    children?: ReactNode;
}

export default function NuiAccordion({ header, isOpen = false, children }: NuiAccordionTitleProps) {
    const [isOpenAccordion, setIsOpenAccordion] = useState(isOpen);
    function onClickArrow() {
        setIsOpenAccordion(!isOpenAccordion);
    }

    return (
        <div className="nui-accordion-component">
            <NuiAccordionHeader title={header} isOpen={isOpenAccordion} onChangeOpen={onClickArrow} />
            {isOpenAccordion ? <div className="nui-accordion-content">{children}</div> : null}
        </div>
    );
}
